import { fabric } from 'fabric';
import { Canvas } from 'fabric/fabric-impl';
import { MutableRefObject } from 'react';
import { getNextInsertPosition } from '../../utils/insertPosition';
import s from '../styles/shapes.module.scss';
import Circle from '../svgs/Circle';
import Square from '../svgs/Square';
import Triangle from '../svgs/Triangle';

const DEFAULT_BRAND_COLORS = ['#FF6961', '#2A2C31', '#171719', '#8CB9FF', '#9BE7A1', '#FFAD42', '#FFFFFF', '#000000'];

const ShapesModule = ({
  canvas,
  brandColors,
}: {
  canvas: MutableRefObject<Canvas | undefined>;
  brandColors?: string[];
}) => {
  const isBackgroundLayer = (object: any) =>
    object?.isBackgroundLayer === true ||
    (object?.type === 'rect' && object?.selectable === false && object?.evented === false) ||
    (object?.type === 'rect' && object?.selectable === false && object?.lockMovementX === true && object?.lockMovementY === true);

  const getNextShapeColor = () => {
    const palette = brandColors && brandColors.length > 0 ? brandColors : DEFAULT_BRAND_COLORS;
    const targetCanvas = canvas.current;
    if (!targetCanvas) return palette[0];

    const shapeCount = targetCanvas
      .getObjects()
      .filter((object: any) => !isBackgroundLayer(object) && ['rect', 'circle', 'triangle'].includes(object?.type || '')).length;

    return palette[shapeCount % palette.length];
  };

  const addShapeToCanvas = (shapeObject: fabric.Object) => {
    const targetCanvas = canvas.current;
    if (!targetCanvas) return;

    targetCanvas.add(shapeObject);
    targetCanvas.bringToFront(shapeObject);
    shapeObject.setCoords();
    targetCanvas.setActiveObject(shapeObject);
    targetCanvas.renderAll();
  };

  const handleShapeClick = (shape: string) => {
    const nextPosition = getNextInsertPosition(canvas.current, { step: 15, cascadeCount: 30 });
    const nextColor = getNextShapeColor();
    if (shape === 'square') {
      const rect = new fabric.Rect({
        height: 280,
        width: 200,
        fill: nextColor,
        rx: 0,
        ry: 0,
        left: nextPosition.left,
        top: nextPosition.top,
      });
      addShapeToCanvas(rect);
    } else if (shape === 'circle') {
      const circle = new fabric.Circle({
        radius: 50,
        height: 100,
        width: 100,
        fill: nextColor,
        left: nextPosition.left,
        top: nextPosition.top,
      });
      addShapeToCanvas(circle);
    } else if (shape === 'triangle') {
      const triangle = new fabric.Triangle({
        height: 280,
        width: 200,
        fill: nextColor,
        left: nextPosition.left,
        top: nextPosition.top,
      });
      addShapeToCanvas(triangle);
    }
  };

  return (
    <div className={s.container}>
      <ul>
        <li onClick={() => handleShapeClick('square')}>
          <Square color={'#fff'} />
          <p>Square</p>
        </li>
        <li onClick={() => handleShapeClick('circle')}>
          <Circle color={'#fff'} />
          <p>Circle</p>
        </li>
        <li onClick={() => handleShapeClick('triangle')}>
          <Triangle color={'#fff'} />
          <p>Triangle</p>
        </li>
      </ul>
    </div>
  );
};

export default ShapesModule;
